export default __webpack_public_path__ + "static/media/cyclops_5.2d9256d5.svg";